import React from 'react';
import Dropdown from 'react-dropdown';
import { authContext } from '../adalConfig';
import axios from 'axios';
import { CSVLink } from "react-csv";
import { sanitizeCsvData } from './csvSanitizer';
import * as appsettings from './constants';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import Modal from 'react-modal';
import 'react-dropdown/style.css';
import './Modal.css';
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        height: '500px',
        width: '560px',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};
export class EngineeringDetails extends React.Component {
    displayName = EngineeringDetails.name
    constructor() {
        super();

        this.state = {
            Metric: [], environment: appsettings.options[0], loading: false, DSMService: '', Service: '', Component: '',
            AKV: '', ActiveActive: '', AutoCerttoCMP: '', AzureContainer: '', AzurePaaS: '', ConfigusingAzureOps: '',
            Oneclick: '', ServiceType: '', TiP: '', WatchDog: '', ZDD: '', userId: '', ServiceTech: '', Storage: '', AdditionmodalIsOpen: false,
            Capabilities: [], ServiceTechOptions: [], StorageOptions: [], ServiceTreeOptions: [], selected: -1, disabled: true, ServiceTree: '', RepoName: '', Criticality: '',
            DevOwner: '', ServiceSubType: '', ServiceLine: '', Comments: ''
        };

    }
    componentDidMount() {
        this.getData(this.state.environment.label);
        var user = authContext.getCachedUser();
        var userId = user.userName;
        var domainIndex = userId.indexOf('@microsoft.com');
        userId = userId.substr(0, domainIndex);
        this.setState({
            userId: userId
        })

    }
    openModal(row) {
        this.setState({ modalIsOpen: true });
    }
    closeModal() {
        this.setState({ modalIsOpen: false });
    }
    afterOpenModal() {
        this.subtitle.style.color = '#f00';
    }
    openAdditionModal() {
        this.getCapabilities();
        this.setState({ AdditionmodalIsOpen: true });
    }
    closeAdditionModal() {
        this.setState({ AdditionmodalIsOpen: false });
    }
    afterOpenAdditionModal() {
        this.subtitle.style.color = '#f00';
    }
    onSelectEnvironment(event) {
        this.setState({
            environment: event
        });
        this.getData(event.label);
    }
    getStorageOptions() {
        var apilink = "api/CosmosApi/GetDropdownOptions/?rowkey=StorageOptions";
        const token = authContext.getCachedToken(authContext.config.clientId);
        axios.get(apilink,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            this.setState({
                StorageOptions: response.data
            });
        });
    }
    getServiceTechOptions() {
        var apilink = "api/CosmosApi/GetDropdownOptions/?rowkey=ServiceTechOptions";
        const token = authContext.getCachedToken(authContext.config.clientId);
        axios.get(apilink,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            this.setState({
                ServiceTechOptions: response.data
            });
        });
    }
    getServiceTreeOptions() {
        var apilink = "api/CosmosApi/GetDropdownOptions/?rowkey=ServiceTreeOptions";
        const token = authContext.getCachedToken(authContext.config.clientId);
        axios.get(apilink,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then(response => {
            this.setState({
                ServiceTreeOptions: response.data
            });
        });
    }
    getCapabilities() {
        var apilink = "api/CosmosApi/GetDSMService/";
        const token = authContext.getCachedToken(authContext.config.clientId);
        axios.get(apilink,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            this.setState({
                loading: false,
                Capabilities: response.data
            })
        });
    }
    getData(environment) {
        this.setState({
            loading: true
        });
        var apilink = "api/CosmosApi/GetEngineeringDetails/";
        const token = authContext.getCachedToken(authContext.config.clientId);
        axios.get(apilink,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            this.setState({
                loading: false,
                Metric: response.data
            })
        });
        this.getStorageOptions();
        this.getServiceTechOptions();
        this.getServiceTreeOptions();
    }
    onChangeDSMService(selectedOption) {
        this.setState({ DSMService: selectedOption.value });
    }
    onChangeService(event) {
        this.setState({ Service: event.target.value });
    }
    onChangeComponent(event) {
        this.setState({ Component: event.target.value });
    }
    onChangeServiceType(selectedOption) {
        this.setState({ ServiceType: selectedOption.value });
    }
    onChangeServiceTech(selectedOption) {
        this.setState({ ServiceTech: selectedOption.value });
    }
    onChangeStorage(selectedOption) {
        this.setState({ Storage: selectedOption.value });
    }
    onChangeAKV(selectedOption) {
        this.setState({ AKV: selectedOption.value });
    }
    onChangeActiveActive(selectedOption) {
        this.setState({ ActiveActive: selectedOption.value });
    }
    onChangeAutoCerttoCMP(selectedOption) {
        this.setState({ AutoCerttoCMP: selectedOption.value });
    }
    onChangeAzureContainer(selectedOption) {
        this.setState({ AzureContainer: selectedOption.value });
    }
    onChangeAzurePaaS(selectedOption) {
        this.setState({ AzurePaaS: selectedOption.value });
    }
    onChangeConfigusingAzureOps(selectedOption) {
        this.setState({ ConfigusingAzureOps: selectedOption.value });
    }
    onChangeOneclick(selectedOption) {
        this.setState({ Oneclick: selectedOption.value });
    }
    onChangeTiP(selectedOption) {
        this.setState({ TiP: selectedOption.value });
    }
    onChangeWatchDog(selectedOption) {
        this.setState({ WatchDog: selectedOption.value });
    }
    onChangeZDD(selectedOption) {
        this.setState({ ZDD: selectedOption.value });
    }
    onChangeServiceTree(selectedOption) {
        this.setState({ ServiceTree: selectedOption.value });
    }
    onChangeRepoName(selectedOption) {
        this.setState({ RepoName: selectedOption.target.value });
    }
    onChangeCriticality(selectedOption) {
        this.setState({ Criticality: selectedOption.value });
    }
    onChangeDevOwner(selectedOption) {
        this.setState({ DevOwner: selectedOption.target.value });
    }
    onChangeServiceSubType(selectedOption) {
        this.setState({ ServiceSubType: selectedOption.value });
    }
    onChangeServiceLine(selectedOption) {
        this.setState({ ServiceLine: selectedOption.target.value });
    }
    onChangeComments(selectedOption) {
        this.setState({ Comments: selectedOption.target.value });
    }
    submitComment() {
        var apilink = "api/CosmosApi/GetUpdateEngineeringDetails/?service="
            + this.state.Service + "&component="
            + this.state.Component + "&AKV="
            + this.state.AKV + "&ActiveActive="
            + this.state.ActiveActive + "&AutoCerttoCMP="
            + this.state.AutoCerttoCMP + "&AzureContainer="
            + this.state.AzureContainer + "&AzurePaaS="
            + this.state.AzurePaaS + "&ConfigusingAzureOps="
            + this.state.ConfigusingAzureOps + "&OneClick="
            + this.state.Oneclick + "&serviceType="
            + this.state.ServiceType + "&Tip="
            + this.state.TiP + "&WatchDog="
            + this.state.WatchDog + "&ServiceTech="
            + this.state.ServiceTech + "&Storage="
            + this.state.Storage + "&ZDD="
            + this.state.ZDD + "&serviceTree="
            + this.state.ServiceTree + "&repoName="
            + this.state.RepoName + "&criticality="
            + this.state.Criticality + "&devOwner="
            + this.state.DevOwner + "&serviceSubType="
            + this.state.ServiceSubType + "&serviceLine="
            + this.state.ServiceLine + "&comments="
            + this.state.Comments;
        const token = authContext.getCachedToken(authContext.config.clientId);
        axios.put(apilink, null,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            alert(response.data);
            this.getData(this.state.environment.label);
        });
        this.closeModal();
    }
    AddService() {
        var apilink =  "api/CosmosApi/GetAddEngineeringDetails/?DSMService="
            + this.state.DSMService + "&service="
            + this.state.Service + "&component="
            + this.state.Component + "&AKV="
            + this.state.AKV + "&ActiveActive="
            + this.state.ActiveActive + "&AutoCerttoCMP="
            + this.state.AutoCerttoCMP + "&AzureContainer="
            + this.state.AzureContainer + "&AzurePaaS="
            + this.state.AzurePaaS + "&ConfigusingAzureOps="
            + this.state.ConfigusingAzureOps + "&OneClick="
            + this.state.Oneclick + "&serviceType="
            + this.state.ServiceType + "&Tip="
            + this.state.TiP + "&WatchDog="
            + this.state.WatchDog + "&ServiceTech="
            + this.state.ServiceTech + "&Storage="
            + this.state.Storage + "&ZDD="
            + this.state.ZDD + "&ServiceTree="
            + this.state.ServiceTree + "&RepoName="
            + this.state.RepoName + "&Criticality="
            + this.state.Criticality + "&devOwner="
            + this.state.DevOwner + "&serviceSubType="
            + this.state.ServiceSubType + "&serviceLine="
            + this.state.ServiceLine + "&comments="
            + this.state.Comments;
        const token = authContext.getCachedToken(authContext.config.clientId);
        axios.post(apilink, null,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            alert(response.data);
            this.getData(this.state.environment.label);
        });
        this.closeAdditionModal();
    }
    deleteservice() {
        var apilink = "api/CosmosApi/GetDeleteEngineeringDetails/?component=" + this.state.Component + "&service=" + this.state.Service;
        console.log(apilink);
        const token = authContext.getCachedToken(authContext.config.clientId);
        axios.delete(apilink,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            if (response.data === 1) {
                alert('Record deleted successfully');
                this.getData(this.state.environment.label);
            }
            else {
                alert('You are not authorized to delete the record');
            }

        });
    }
    openHelp() {
        const url = appsettings.HelpPageRootURL;
        const w = window.open(url, '_blank', 'noopener,noreferrer');
        if (w != null) {
            w.opener = null;
        } else {
            window.location.href = url;
        }
    }
    render() {
        return (
            <div>
                <div id="banner">
                    <h4 id="header">{appsettings.EngineeringDetailsHeader}</h4>
                </div>

                <div style={{ height: '8%', width: '100%', display: 'inline-flex', marginTop: '-3%' }}>
                    <button style={{ marginTop: '4%', height: '25px' }} onClick={this.openAdditionModal.bind(this)}>Add Service</button>
                    <CSVLink data={sanitizeCsvData(this.state.Metric)} filename={"EngineeringDetails.csv"} className="csvExport" headers={appsettings.EngineeringDetailscsvHeaders}>Export to csv</CSVLink>
                    {/* Changed: use anchor to always open in a new tab */}
                    <a
                        id='HelpButton'
                        href={appsettings.HelpPageRootURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="ECTelemetry Wiki"
                        aria-label="ECTelemetry Wiki"
                        style={{ marginLeft: '10px' }}
                    >
                        ECTelemetry Wiki
                    </a>
                </div>
                <hr />
                <ReactTable
                    data={this.state.Metric}
                    columns={appsettings.EngineeringDetailscolumns}
                    minRows={0}
                    maxRows={500}
                    defaultPageSize={100}
                    showPagination={true}
                    sortable={true}
                    filterable={true}
                    loading={this.state.loading}
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value}
                    style={{
                        borderStyle: 'solid',
                        borderWidth: "1px",
                        overflow: "hidden",
                    }}
                    className="-striped "
                    getTdProps={(state, rowInfo, column, instance) => {
                        return {
                            style: {
                                borderColor: "#f7f7f7",
                                textAlign: 'center',
                                fontSize: '12px',
                                padding: '1px',
                                borderWidth: '1px',
                                wordWrap: 'break-word',
                                whiteSpace: 'pre-wrap',
                                background: rowInfo.index === this.state.selected ? '#96B1C7' : ''
                            },
                            onClick: (e) => {
                                this.setState({
                                    Component: this.state.Metric[rowInfo.index].RowKey,
                                    Service: this.state.Metric[rowInfo.index].PartitionKey,
                                    DSMService: this.state.Metric[rowInfo.index].DSMService,
                                    ServiceType: this.state.Metric[rowInfo.index].ServiceType,
                                    ServiceTech: this.state.Metric[rowInfo.index].ServiceTech,
                                    Storage: this.state.Metric[rowInfo.index].Storage,
                                    AKV: this.state.Metric[rowInfo.index].AKV,
                                    ActiveActive: this.state.Metric[rowInfo.index].ActiveActive,
                                    AutoCerttoCMP: this.state.Metric[rowInfo.index].AutoCerttoCMP,
                                    AzureContainer: this.state.Metric[rowInfo.index].AzureContainer,
                                    AzurePaaS: this.state.Metric[rowInfo.index].AzurePaaS,
                                    ConfigusingAzureOps: this.state.Metric[rowInfo.index].ConfigusingAzureOps,
                                    Oneclick: this.state.Metric[rowInfo.index].Oneclick,
                                    TiP: this.state.Metric[rowInfo.index].TiP,
                                    WatchDog: this.state.Metric[rowInfo.index].WatchDog,
                                    ZDD: this.state.Metric[rowInfo.index].ZDD,
                                    ServiceTree: this.state.Metric[rowInfo.index].ServiceTree,
                                    RepoName: this.state.Metric[rowInfo.index].RepoName,
                                    Criticality: this.state.Metric[rowInfo.index].Criticality,
                                    DevOwner: this.state.Metric[rowInfo.index].DevOwner,
                                    ServiceSubType: this.state.Metric[rowInfo.index].ServiceSubType,
                                    ServiceLine: this.state.Metric[rowInfo.index].ServiceLine,
                                    Comments: this.state.Metric[rowInfo.index].Comments
                                });
                                this.openModal(rowInfo.index);
                            }
                        };
                    }}
                    getTheadThProps={() => {
                        return {
                            style: {
                                background: "#f7f7f7",
                                borderColor: "#f7f7f7",
                                color: 'black',
                                textAlign: 'left',
                                fontSize: '11px',
                                height: '30px',
                                fontWeight: 'bold'
                            }
                        };
                    }}
                />
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.closeModal.bind(this)}
                    style={customStyles}
                    ariaHideApp={false}
                    contentLabel="Example Modal"
                >
                    <h2 className="header">Update Details</h2>

                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Component :</p><input className="EngExcelDropdown" type="text" value={this.state.Component} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">ServiceType :</p><Dropdown className='EngExcelDropdown' options={appsettings.AllowedServiceTypes} onChange={this.onChangeServiceType.bind(this)} value={this.state.ServiceType} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">ComponetType :</p><Dropdown className='EngExcelDropdown' options={this.state.StorageOptions} onChange={this.onChangeStorage.bind(this)} value={this.state.Storage} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">ServiceTech :</p><Dropdown className='EngExcelDropdown' options={this.state.ServiceTechOptions} onChange={this.onChangeServiceTech.bind(this)} value={this.state.ServiceTech} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">AKV :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeAKV.bind(this)} value={this.state.AKV} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Active-Active :</p><Dropdown className='EngExcelDropdown' options={appsettings.ActiveActiveOptions} onChange={this.onChangeActiveActive.bind(this)} value={this.state.ActiveActive} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Auto Cert to CMP :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeAutoCerttoCMP.bind(this)} value={this.state.AutoCerttoCMP} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Azure Container:</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeAzureContainer.bind(this)} value={this.state.AzureContainer} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Azure PaaS :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeAzurePaaS.bind(this)} value={this.state.AzurePaaS} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Config using AzureOps :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeConfigusingAzureOps.bind(this)} value={this.state.ConfigusingAzureOps} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">One Click :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeOneclick.bind(this)} value={this.state.Oneclick} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">TiP :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeTiP.bind(this)} value={this.state.TiP} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">WatchDog :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeWatchDog.bind(this)} value={this.state.WatchDog} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">ZDD :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeZDD.bind(this)} value={this.state.ZDD} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Criticality :</p><Dropdown className='EngExcelDropdown' options={appsettings.AllowedCriticality} onChange={this.onChangeCriticality.bind(this)} value={this.state.Criticality} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">ServiceTree :</p><Dropdown className="EngExcelDropdown" options={this.state.ServiceTreeOptions}  value={this.state.ServiceTree} onChange={this.onChangeServiceTree.bind(this)} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">RepoName :</p><input className="EngExcelDropdown" type="text" value={this.state.RepoName} onChange={this.onChangeRepoName.bind(this)} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">DevOwner :</p><input className='EngExcelDropdown' type="text" onChange={this.onChangeDevOwner.bind(this)} value={this.state.DevOwner} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">ServiceSubType :</p><Dropdown className='EngExcelDropdown' options={appsettings.AllowedServiceSubType} onChange={this.onChangeServiceSubType.bind(this)} value={this.state.ServiceSubType} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">ServiceLine :</p><input className="EngExcelDropdown" type="text" value={this.state.ServiceLine} onChange={this.onChangeServiceLine.bind(this)} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Comments :</p><input className="EngExcelDropdown" type="text" value={this.state.Comments} onChange={this.onChangeComments.bind(this)} /></div>

                    <button onClick={this.submitComment.bind(this)} className="CommentSubmit" >Submit</button>

                </Modal>

                <Modal
                    isOpen={this.state.AdditionmodalIsOpen}
                    onRequestClose={this.closeAdditionModal.bind(this)}
                    style={customStyles}
                    ariaHideApp={false}
                    contentLabel="Example Modal"
                >
                    <h2 className="header">Add Service</h2>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">DSM Service :</p><Dropdown className='EngExcelDropdown' options={this.state.Capabilities} onChange={this.onChangeDSMService.bind(this)} value={this.state.DSMService} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Service :</p><input className="EngExcelTextInput" type="text" onBlur={this.onChangeService.bind(this)} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Component :</p><input className="EngExcelTextInput" type="text" onBlur={this.onChangeComponent.bind(this)} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">ServiceType :</p><Dropdown className='EngExcelDropdown' options={appsettings.AllowedServiceTypes} onChange={this.onChangeServiceType.bind(this)} value={this.state.ServiceType} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">ComponetType :</p><Dropdown className='EngExcelDropdown' options={this.state.StorageOptions} onChange={this.onChangeStorage.bind(this)} value={this.state.Storage} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">ServiceTech :</p><Dropdown className='EngExcelDropdown' options={this.state.ServiceTechOptions} onChange={this.onChangeServiceTech.bind(this)} value={this.state.ServiceTech} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">AKV :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeAKV.bind(this)} value={this.state.AKV} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Active-Active :</p><Dropdown className='EngExcelDropdown' options={appsettings.ActiveActiveOptions} onChange={this.onChangeActiveActive.bind(this)} value={this.state.ActiveActive} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Auto Cert to CMP :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeAutoCerttoCMP.bind(this)} value={this.state.AutoCerttoCMP} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Azure Container:</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeAzureContainer.bind(this)} value={this.state.AzureContainer} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Azure PaaS :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeAzurePaaS.bind(this)} value={this.state.AzurePaaS} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Config using AzureOps :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeConfigusingAzureOps.bind(this)} value={this.state.ConfigusingAzureOps} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">One Click :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeOneclick.bind(this)} value={this.state.Oneclick} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">TiP :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeTiP.bind(this)} value={this.state.TiP} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">WatchDog :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeWatchDog.bind(this)} value={this.state.WatchDog} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">ZDD :</p><Dropdown className='EngExcelDropdown' options={appsettings.booleanOptions} onChange={this.onChangeZDD.bind(this)} value={this.state.ZDD} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Criticality :</p><Dropdown className='EngExcelDropdown' options={appsettings.AllowedCriticality} onChange={this.onChangeCriticality.bind(this)} value={this.state.Criticality} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">ServiceTree :</p><Dropdown className="EngExcelDropdown" options={this.state.ServiceTreeOptions} value={this.state.ServiceTree} onChange={this.onChangeServiceTree.bind(this)} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">RepoName :</p><input className="EngExcelDropdown" type="text" value={this.state.RepoName} onChange={this.onChangeRepoName.bind(this)} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">DevOwner :</p><input className='EngExcelDropdown' type="text" onChange={this.onChangeDevOwner.bind(this)} value={this.state.DevOwner} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">ServiceSubType :</p><Dropdown className='EngExcelDropdown' options={appsettings.AllowedServiceSubType} onChange={this.onChangeServiceSubType.bind(this)} value={this.state.ServiceSubType} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">ServiceLine :</p><input className="EngExcelDropdown" type="text" value={this.state.ServiceLine} onChange={this.onChangeServiceLine.bind(this)} /></div>
                    <div className="EngExcelSelectorDiv"><p className="EngExcelLabel">Comments :</p><input className="EngExcelDropdown" type="text" value={this.state.Comments} onChange={this.onChangeComments.bind(this)} /></div>

                    <button onClick={this.AddService.bind(this)} className="CommentSubmit" >Submit</button>

                </Modal>
            </div>
        );
    }
}